// extracted by mini-css-extract-plugin
export default {"buttons":"Dashboard_buttons__3kQgc","dataGrid":"Dashboard_dataGrid__hAjjR"};